<template>
  {{ msg }}
</template>

<script>
import { useRouter } from "vue-router";

export default {
  props: {
    msg: { type: String, default: "Helaas, er is een fout gebeurd." },
  },
  setup(props) {
    const router = useRouter();

    return {
      msg: router.currentRoute.value.query.msg || props.msg,
    };
  },
};
</script>
